import React, { useState, useEffect, Fragment, useCallback, useContext } from 'react';
import { toast } from 'react-toastify';
import { styles } from './styles';
import * as moment from 'moment';
import { CSVLink } from 'react-csv';
import { useTranslation } from 'react-i18next';
import access from 'config/access';

// custom pages
import Table from 'components/Table/Table';
import Loader from 'components/Loader/Loader';
import searchIcon from 'assets/img/Search_Icon.png';
import Context from 'context/context';

// material-ui
import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { Typography } from '@material-ui/core';
import ConsentApprovalAPI from 'apis/ConsentApproval/ConsentApproval';
import InputAdornment from '@material-ui/core/InputAdornment';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MenuItem from '@material-ui/core/MenuItem';
import { Modal, Backdrop, Fade } from '@material-ui/core';

// material-ui icons
import Grid from '@material-ui/core/Grid';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';
import { blockInvalidChar } from 'helpers/blockInvalidChar';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import CircularProgress from '@material-ui/core/CircularProgress';

//Helpers
import useDebounce from 'helpers/useDebounce';
import {dateFormat} from "helpers/dataFormat"


// custom TextField
const CssTextField = withStyles({
  root: {
    '& label.Mui-focused': {
      color: '##D3D3D3',
    },
    '& .MuiFormLabel-root': {
      color: '#707070',
    },
    '& .MuiInputBase-input': {
      color: '#707070',
    },
    '& .MuiInput-underline:before': {
      borderBottomColor: '#707070!important',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#707070!important',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#707070',
      },
      '&:hover fieldset': {
        borderColor: '#707070',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#707070',
      },
      '&.MuiOutlinedInput-root': {
        borderRadius: 20,
      },
      '&.MuiOutlinedInput-root': {
        marginTop: 0,
        borderRadius: 20,
      },
    },
  },
})(TextField);

const formLabelsTheme = createMuiTheme({
  overrides: {
    MuiFormLabel: {
      asterisk: {
        color: '#db3131',
        '&$error': {
          color: '#db3131',
        },
      },
    },
  },
  palette: {
    primary: {
      main: '#616161',
    },
  },
});

const tabs = [
  {
    tabName: 'Pending Approval',
    tab: 0,
  },
  {
    tabName: 'Upload Consent',
    tab: 1,
  },
  {
    tabName: 'Approved Consent',
    tab: 2,
  },
  {
    tabName: 'Rejected Consent',
    tab: 3,
  },
];

const exportHeadersApproved = [
  {
    label: 'Loyalty ID',
    key: 'loyalty_id',
  },
  {
    label: 'Bill To',
    key: 'customer_billto_account_number',
  },
  {
    label: "Submitter's First / Last Name",
    key: 'full_name',
  },
  {
    label: "Submitter's Email",
    key: 'email',
  },
  {
    label: "Uploaded At",
    key: 'created_at',
  },
  {
    label: "Consented",
    key: 'consented',
  },
  {
    label: "Approved By",
    key: 'modified_by.email',
  },
  {
    label: "Approved At",
    key: 'updated_at',
  },
];
const exportHeadersUpload = [
  {
    label: 'Loyalty ID',
    key: 'loyalty_id',
  },
  {
    label: 'Bill To',
    key: 'customer_billto_account_number',
  },

  {
    label: "Consented",
    key: 'consent_flag',

  },
];
const exportHeadersRejected = [
  {
    label: 'Loyalty ID',
    key: 'loyalty_id',
  },
  {
    label: 'Bill To',
    key: 'customer_billto_account_number',
  },
  {
    label: "Submitter's First / Last Name",
    key: 'full_name',
  },
  {
    label: "Uploaded At",
    key: 'created_at',
  },
  {
    label: "Consented",
    key: 'consent_flag',
  },
  {
    label: "Rejected By",
    key: 'modified_by.email',
  },
  {
    label: "Rejected At",
    key: 'updated_at',
  },
  {
    label: "Rejected Reason",
    key: 'reason',
  },
];

const exportHeadersPending = [
  {
    label: 'Loyalty ID',
    key: 'loyalty_id',
  },
  {
    label: 'Bill To',
    key: 'customer_billto_account_number',
  },
  {
    label: "Submitter's First / Last Name",
    key: 'full_name',
  },

  {
    label: "Submitter’s Email",
    key: 'email',
  },
  {
    label: "Uploaded At",
    key: 'created_at',
  },
  {
    label: "Consented",
    key: 'consent_flag',
  },
  
  {
    label: "Document",
    key: 'file_name',
  },
  
];

const ConsentApproval = () => {
  const { state, dispatch } = useContext(Context);
  const {
    getConsentApproval,
    updateConsent,
    search,
    upload,
    getReasonDescription,
    exportAPI,
  } = ConsentApprovalAPI();
  const [data, setData] = useState([]);
  const classes = styles();
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [searchValue, setSearchValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [selectedBtn, setSelectedBtn] = useState(0);
  const [dialogData, setDialogData] = useState({});
  const [rejectDialogData, setRejectDialogData] = useState({});
  const [updateLoading, setUpdateLoading] = useState(false);
  const [file, setFile] = useState({});
  const [fileType, setFileType] = useState('');
  const [fileName, setFileName] = useState('');
  const [exportData, setExportData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [image, setImage] = useState('');
  const [imageType, setImageType] = useState('');
  const { t, i18n } = useTranslation();

  let searchBounceValues = useDebounce(() => {
    return searchValue === '' ? '' : searchValue;
  });

  // Common State Object
  const [states, setstates] = useState({
    clearSearch: false,
    reasonDescription: [],
  });

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  const { clearSearch, reasonDescription } = states;

  // tier api func
  useEffect(() => {
    handleGetReason();
  }, []);

  // tier api func
  const handleGetReason = async () => {
    try {
      let res = await getReasonDescription();
      if (res) {
        setStates({ reasonDescription: res.data });
      }
    } catch (e) {
      console.log({ e });
    }
  };

  useEffect(() => {
    dispatch({ type: 'SET_PATHNAME', payload: ['HOME', 'ADMIN', 'Consent Approval'] });
  }, []);

  useEffect(() => {
    if (!clearSearch) {
      if (searchBounceValues && searchBounceValues.length > 0) {
        handleSearch();
      } else if (searchValue?.length === 0) {
        handleGetConsent();
      }
    } else {
      setStates({ clearSearch: false });
    }
  }, [searchBounceValues, offset, selectedBtn]);

  const handleGetConsent = async () => {
    try {
      setLoading(true);
      let values = {
        offset: (offset - 1) * 10,
        limit: 10,
        type: selectedBtn,
      };
      let res = await getConsentApproval(values);
      setLoading(false);
      setData(res?.data);
      setCount(res?.count);
    } catch (e) {
      console.log({ e });
    }
  };

  const handleSearch = async () => {
    try {
      setLoading(true);
      let values = {
        offset: (offset - 1) * 10,
        limit: 10,
        search: searchValue,
        type: selectedBtn,
      };
      let res = await search(values);
      setLoading(false);
      setData(res?.data);
      setCount(res?.count);
    } catch (e) {
      console.log({ e });
    }
  };

  async function handleUpdate(data) {
    try {
      let res = await updateConsent(data);
      if (res) {
        toast.success(i18n.language === 'fr' ? res.french_message : res.message);
        if (data?.type === 'REJECTED') {
          setRejectDialogData({});
        }
        handleGetConsent();
      }
    } catch (error) {
      console.log({ error });
    }
  }

  async function handleExport() {
    try {
      setLoading(true);
      let data = {
        type:((selectedBtn == 0 && "Pending")|| (selectedBtn == 2 && "Approved") || (selectedBtn == 1 && "Not Approved") || (selectedBtn == 3 && "Rejected"))
      };
      if (searchBounceValues) {
        data = { ...data, search: searchBounceValues };
      }
      let res = await exportAPI(data);
      setLoading(false);
      if (res && res?.data) {
        setExportData(res?.data.map(i => {
          return {
            ...i,
            full_name: i.first_name + " " + i.last_name,
            consented: 'Yes'
          }
        }));
        return true;
      } else {
        toast.error(t("No Data Found"), { toastId: 1 })
      }
    } catch (error) {
      console.log({ error });
    }
  }

  const handlePagination = (value) => {
    setOffset(value);
  };

  async function handleSubmit() {
    try {
      setUpdateLoading(true);
      let input = new FormData();
      input.append('fileName', fileName);
      input.append('fileType', fileType);
      input.append('file', file);
      input.append('loyaltyId', dialogData?.loyaltyId);
      let res = await upload(input);
      if (res && res?.type === 'success') {
        toast.success(res?.message ? i18n.language === 'fr' ? res?.french_message : res?.message : t('Something Went Wrong'), {
          toastId: 'upload-success',
        });
      }
      if (res && res?.type === 'error') {
        toast.error(res?.message ? i18n.language === 'fr' ? res?.french_message : res?.message : t('Something Went Wrong'), {
          toastId: 'upload-error',
        });
      }
      setDialogData({});
      setFile({});
      setFileType('');
      setFileName('');
      setUpdateLoading(false);
      if (offset === 1) {
        handleGetConsent();
      } else {
        setOffset(1);
      }
      return;
    } catch (e) {
      console.log({ e });
    }
  }

  const handleImage = (value, token, type) => {
    let url = `${value}${token}`;
    setImage(url);
    setImageType(type);
    setOpenModal(true);
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  function handleExportHeaders() {
    let arr = [];
    if (selectedBtn == 1) {
      arr = [...exportHeadersUpload]
    } else if (selectedBtn == 2) {
      arr = [...exportHeadersApproved]
    } else if (selectedBtn == 3) {
      arr = [...exportHeadersRejected]
    }
      else if (selectedBtn == 0) {
    arr = [...exportHeadersPending]
  }
    return arr.map(h => {
      return { ...h, label: t(h.label) }
    })
  }

  return (
    <Fragment>
      <Loader>
        <Grid
          container
          spacing={0}
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <div>
            <CssTextField
              id='enterPassword'
              placeholder={t('Search for Loyalty Id or Billto Id')}
              type={'number'}
 onWheel={(e) => e.target.blur()}
              variant='outlined'
              autoComplete='off'
              onKeyDown={blockInvalidChar}
              className={classes.searchInput}
              InputProps={{
                endAdornment: (
                  <InputAdornment position='end'>
                    {searchValue.length > 0 ? (
                      <CloseOutlinedIcon
                        className={classes.searchInputIcon}
                        onClick={() => {
                          setLoading(true);
                          setStates({ clearSearch: true });
                          setSearchValue('');
                          if (offset === 1) {
                            handleGetConsent();
                          } else {
                            setOffset(1);
                          }
                        }}
                      />
                    ) : (
                      <img
                        src={searchIcon}
                        alt=''
                        width='20px'
                        className={classes.searchInputIcon}
                      />
                    )}
                  </InputAdornment>
                ),
              }}
              value={searchValue}
              onChange={(e) => {
                e.target.value.replace(/\s+/g, '').length === 0
                  ? setSearchValue('')
                  : setSearchValue(e.target.value);
                setOffset(1);
                if (e.target.value.length === 0) {
                  handleGetConsent();
                }
              }}
            />
            {tabs.map((data, i) => (
              <React.Fragment key={t.tabName}>
                <button
                  type='button'
                  className={`${selectedBtn === data.tab
                    ? classes.tabSelected
                    : classes.tabNotSelected
                    }`}
                  disabled={loading}
                  key={data.tabName}
                  onClick={() => {
                    if (searchValue?.length > 0) {
                      setLoading(true);
                      setSearchValue('');
                      setStates({ clearSearch: true });
                    }
                    setOffset(1);
                    setSelectedBtn(parseInt(data.tab));
                  }}
                >
                  {t(data.tabName)}
                </button>
              </React.Fragment>
            ))}
          </div>
          <CSVLink
            id='csv'
            data={exportData}
            headers={handleExportHeaders()}
            filename={((selectedBtn == 3 && t('Rejected Consent')) || (selectedBtn == 1 && t('Upload Consent')) || (selectedBtn == 2 && t('Approved Consent')) ||(selectedBtn == 0 && t('Pending Consent')))
              +
              ' ' +
              moment(new Date()).format('MM-DD-YYYY,h:mm A') +
              '.csv'
            }
            className={classes.CSVlink}
          />
          {(selectedBtn == 1 || selectedBtn == 2 || selectedBtn == 3 || selectedBtn == 0) && (
            <button
              type='button'
              className={classes.exportBtn}
              onClick={async () => {
                let res = await handleExport();
                if (res) {
                  document.getElementById('csv').click();
                }
              }}
              disabled={loading}
            >
              {t('Export')}
            </button>
          )}
        </Grid>
        {selectedBtn === 0 && (
          <div className={classes.tableDiv}>
            <Loader Loading={loading} top={'15%'}>
              <Table
                headings={[
                  'Loyalty Id',
                  'Billto',
                  'Submitter’s First/Last Name',
                  'Submitter’s Email',
                  'Uploaded At',
                  'Consented',
                  'Document',
                  'Approve / Reject',
                ]}
                data={data?.map((p, i) => [
                  p?.['loyalty_id'],
                  p?.['customer_billto_account_number'],
                  p?.['first_name'] + ' ' + p?.['last_name'],
                  p?.['email'] ? p?.['email'] : '-',
                  p?.['created_at']
                    ? dateFormat(p?.['created_at'], i18n.language)
                    : '-',
                  p?.['consent_flag'] ? t('Yes') : t('No'),
                  p?.['url'] ? (
                    <a
                      //href={p?.["url"]} target="_blank"
                      key={i}
                      onClick={() =>
                        handleImage(
                          p?.['url'],
                          p?.['blob_sas_token'],
                          p?.['file_type']
                        )
                      }
                    >
                      {t("View")}
                    </a>
                  ) : (
                    '-'
                  ),
                  !p?.['consent_flag'] && p?.['user_id']
                    ? [
                      <div style={{ display: 'flex' }} key={i}>
                        <div title='Approve' key={p?.['loyalty_id']}>
                          <CheckCircleOutlineIcon
                            className={classes.approveDiv}
                            onClick={() => {
                              if (state?.userInfo?.editAction) {
                                let obj = {
                                  type: 'APPROVED',
                                  id: p?.['id'],
                                };
                                handleUpdate(obj);
                                return;
                              }
                              else {
                                toast.error(state.userInfo?.editAccess)
                                return;
                              }
                            }}
                          />
                        </div>
                        <div title='Reject' key={p?.['id']}>
                          <HighlightOffIcon
                            className={classes.declineDiv}
                            onClick={() => {
                              if (state?.userInfo?.editAction) {
                                setRejectDialogData({
                                  id: p?.['id'],
                                  open: true,
                                });
                                return;
                              }
                              else {
                                toast.error(state.userInfo?.editAccess)
                                return;
                              }
                            }}
                          />
                        </div>
                      </div>,
                    ]
                    : '-',
                ])}
                offset={offset}
                count={
                  (count / 10) % 1 === 0
                    ? Math.floor(count / 10)
                    : Math.floor(count / 10 + 1)
                }
                handlePagination={handlePagination}
              />
            </Loader>
          </div>
        )}
        {selectedBtn === 1 && (
          <div className={classes.tableDiv}>
            <Loader Loading={loading} top={'15%'}>
              <Table
                headings={[
                  'Loyalty Id',
                  'Billto',
                  'Consented',
                  'Upload Document',
                ]}
                data={data?.map((p, i) => [
                  p?.['loyalty_id'],
                  p?.['customer_billto_account_number'],
                  p?.['consent_flag'] ? t('Yes') : t('No'),
                  <div
                    key={i}
                    style={{ color: 'blue', cursor: 'pointer' }}
                    aria-disabled={!state?.userInfo?.editAction}
                    onClick={() => {
                      console.log({ access });
                      if (state?.userInfo?.editAction) {
                        setDialogData({
                          open: true,
                          loyaltyId: p?.['loyalty_id'],
                        });
                        return;
                      }
                      else {
                        toast.error(state.userInfo?.editAccess)
                        return;
                      }
                    }}
                  >
                    {t("Click here")}
                  </div>,
                ])}
                offset={offset}
                count={
                  (count / 10) % 1 === 0
                    ? Math.floor(count / 10)
                    : Math.floor(count / 10 + 1)
                }
                handlePagination={handlePagination}
              />
            </Loader>
          </div>
        )}
        {selectedBtn === 2 && (
          <div className={classes.tableDiv}>
            <Loader Loading={loading} top={'15%'}>
              <Table
                headings={[
                  'Loyalty Id',
                  'Billto',
                  'Submitter’s First/Last Name',
                  'Submitter’s Email',
                  'Uploaded At',
                  'Consented',
                  'Approved By',
                  'Approved At',
                  'Document',
                ]}
                data={data?.map((p, i) => [
                  p?.['loyalty_id'],
                  p?.['customer_billto_account_number'],
                  p?.['first_name'] + ' ' + p?.['last_name'],
                  p?.['email'] ? p?.['email'] : '-',
                  p?.['created_at']
                    ? dateFormat(p?.['created_at'], i18n.language)
                    : '-',
                  p?.['consent_flag'] ? t('Yes') : t('No'),
                  p?.['modified_by.email'] ? p['modified_by.email'] : '-',
                  p?.['updated_at']
                    ? dateFormat(p?.['updated_at'], i18n.language)
                    : '-',
                  p?.['url'] ? (
                    <a
                      //href={p?.["url"]} target="_blank"
                      key={i}
                      onClick={() =>
                        handleImage(
                          p?.['url'],
                          p?.['blob_sas_token'],
                          p?.['file_type']
                        )
                      }
                    >
                      {t("View")}
                    </a>
                  ) : (
                    '-'
                  ),
                ])}
                offset={offset}
                count={
                  (count / 10) % 1 === 0
                    ? Math.floor(count / 10)
                    : Math.floor(count / 10 + 1)
                }
                handlePagination={handlePagination}
              />
            </Loader>
          </div>
        )}
        {selectedBtn === 3 && (
          <div className={classes.tableDiv}>
            <Loader Loading={loading} top={'15%'}>
              <Table
                headings={[
                  'Loyalty Id',
                  'Billto',
                  'Submitter’s First/Last Name',
                  'Uploaded At',
                  'Consented',
                  'Rejected By',
                  'Rejected At',
                  'Rejected Reason',
                ]}
                data={data?.map((p, i) => [
                  p?.['loyalty_id'],
                  p?.['customer_billto_account_number'],
                  p?.['first_name'] + ' ' + p?.['last_name'],
                  p?.['created_at']
                    ? dateFormat(p?.['created_at'], i18n.language)
                    : '-',
                  p?.['consent_flag'] ? t('Yes') : t('No'),
                  p?.['modified_by.email'] ? p['modified_by.email'] : '-',
                  p?.['updated_at']
                    ? dateFormat(p?.['updated_at'], i18n.language)
                    : '-',
                  p?.['reason'] ? p['reason'] : '-',
                ])}
                offset={offset}
                count={
                  (count / 10) % 1 === 0
                    ? Math.floor(count / 10)
                    : Math.floor(count / 10 + 1)
                }
                handlePagination={handlePagination}
              />
            </Loader>
          </div>
        )}
        {/* Upload Document Dialog */}
        <Dialog
          aria-labelledby='simple-dialog-title'
          open={dialogData?.open ? true : false}
          style={{ fontFamily: 'Segoe-ui' }}
        >
          <div className={classes.dialogParentDiv}>
            <div className={classes.parentText}>
              {t('Upload Customer’s Consent')}
            </div>
            <div className={classes.subParentText}>
              <b>{`${t('Loyalty Id')} :`}</b> {dialogData?.loyaltyId}
            </div>
            <div className={classes.parentText2}>
              &nbsp;&nbsp;&nbsp;
              <span>
                {t("Upload the customer's signed Thrive Rewards Activation Form. Please ensure the customer's practice information and signature are filled in before attaching and providing your approval.")}
              </span>
            </div>
            <br />
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <div className={classes.imgInputDiv}>
                <input
                  id='demo'
                  type='file'
                  accept='image/jpg, image/jpeg, image/png, application/pdf'
                  onChange={(event) => {
                    let fileName = event.target.files?.[0].name;
                    let file = event.target.files?.[0];
                    let type = event.target.files?.[0].type;
                    setFileName(fileName);
                    setFileType(type);
                    setFile(file);
                  }}
                  className={classes.imgInput}
                />
                {!fileName ? (
                  <>
                    <p>{t('Drag and drop/click to upload')}</p>
                    <Typography className={classes.imgBtnUpload}>
                      {t('Upload').toUpperCase()}
                    </Typography>
                  </>
                ) : (
                  <>
                    <p style={{ paddingTop: '25px' }}>{fileName}</p>
                  </>
                )}
              </div>
            </div>
            <br />
            <Grid container spacing={0}>
              {!updateLoading ? (
                <Fragment>
                  {' '}
                  <Grid item xs={6}>
                    <Button
                      className={classes.cancelBtn}
                      disabled={loading}
                      onClick={() => {
                        setDialogData({});
                        setFile({});
                        setFileType('');
                        setFileName('');
                      }}
                    >
                      {t('Cancel')}
                    </Button>
                  </Grid>
                  <Grid item xs={6} className={classes.proceedBtnGrid}>
                    <Button
                      className={classes.proceedBtn}
                      disabled={loading}
                      onClick={() => {
                        if (fileName === '' || fileType === '' || !file) {
                          return toast.error('Please upload the file', {
                            toastId: 'uploadWarning',
                          });
                        }
                        handleSubmit();
                      }}
                    >
                      {t('Approve')}
                    </Button>
                  </Grid>
                </Fragment>
              ) : (
                <Grid item xs={12} className={classes.updateDialogLoader}>
                  <CircularProgress />
                </Grid>
              )}
            </Grid>
          </div>
        </Dialog>
        {/* Reject Reason dialog */}
        <Dialog
          aria-labelledby='simple-dialog-title'
          open={rejectDialogData?.open ? true : false}
          style={{ fontFamily: 'Segoe-ui' }}
        >
          <div className={classes.dialogParentDiv}>
            <div className={classes.parentText}>{t('Confirmation')}</div>
            <br />
            <Fragment>
              <div className={classes.subParentText2}>
                {t('Please choose the reason for updating')}&nbsp;
                <span style={{ color: 'red' }}>*</span>
              </div>
              <div>
                <CssTextField
                  variant='outlined'
                  select
                  fullWidth
                  className={classes.dialogInput}
                  value={
                    rejectDialogData?.reasonType === 'Others'
                      ? rejectDialogData?.reasonType
                      : rejectDialogData?.reason
                  }
                  onChange={(e) => {
                    if (e.target.value === 'Others') {
                      setRejectDialogData({
                        ...rejectDialogData,
                        reasonType: e.target.value,
                        reason: '',
                      });
                    } else {
                      setRejectDialogData({
                        ...rejectDialogData,
                        reason: e.target.value,
                        reasonType: '',
                      });
                    }
                  }}
                >
                  {reasonDescription?.map((d, i) => (
                    <MenuItem value={d?.reason_description} key={i}>
                      {t(d?.reason_description)}
                    </MenuItem>
                  ))}
                </CssTextField>

                {rejectDialogData?.reasonType === 'Others' && (
                  <Fragment>
                    <div className={classes.subParentText2}>
                      {t('Type the Reason')}&nbsp;
                      <span style={{ color: 'red' }}>*</span>
                      &nbsp;
                      <span style={{ fontSize: 12 }}>(Max 120 Characters)</span>
                    </div>
                    <CssTextField
                      id='reason'
                      type={'text'}
                      autoComplete='off'
                      variant='outlined'
                      inputProps={{
                        maxLength: 120,
                      }}
                      className={classes.dialogInput}
                      value={rejectDialogData?.reason}
                      onChange={(e) => {
                        setRejectDialogData({
                          ...rejectDialogData,
                          reason: e.target.value,
                        });
                      }}
                    />
                  </Fragment>
                )}
              </div>
            </Fragment>
            <br />
            {!rejectDialogData?.loading ? (
              <Grid container spacing={0}>
                <Grid item xs={6}>
                  <Button
                    className={classes.cancelBtn}
                    onClick={() => {
                      setRejectDialogData({});
                    }}
                  >
                    {t('Cancel')}
                  </Button>
                </Grid>
                <Grid item xs={6} className={classes.proceedBtnGrid}>
                  <Button
                    className={classes.proceedBtn}
                    onClick={() => {
                      if (state?.userInfo?.editAction) {
                        if (!rejectDialogData?.reason) {
                          return toast.error('Please choose the reason', {
                            toastId: 'empty-reason',
                          });
                        }
                        let obj = {
                          type: 'REJECTED',
                          id: rejectDialogData?.id,
                          reason: rejectDialogData?.reason,
                        };
                        setRejectDialogData({
                          ...rejectDialogData,
                          loading: true,
                        });
                        handleUpdate(obj);
                        return;
                      }
                      else {
                        toast.error(state.userInfo?.editAccess)
                        return;
                      }
                    }}

                  >
                    {t('Update')}
                  </Button>
                </Grid>
              </Grid>
            ) : (
              <Grid item xs={12} className={classes.updateDialogLoader}>
                <CircularProgress />
              </Grid>
            )}
          </div>
        </Dialog>
      </Loader>
      {openModal && (
        <Modal
          className={classes.modal}
          open={openModal}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 300,
          }}
        >
          <Fade in={openModal} timeout={300} className={classes.img}>
            {imageType === 'application/pdf' ? (
              <iframe src={image} width='800' height='600'></iframe>
            ) : (
              <img
                src={image}
                alt='asd'
                style={{ maxHeight: '90%', maxWidth: '90%' }}
              />
            )}
          </Fade>
        </Modal>
      )}
    </Fragment>
  );
};

export default ConsentApproval;
